var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"rules":_vm.rulesArray},on:{"input":_vm.onInput}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }